import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { styled } from '@effektify/theme';
import NextImage from 'next/image';
interface ImageProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  fill?: boolean;
  className?: string;
}
const StyledImage = styled(NextImage)(({
  theme
}) => ({
  borderRadius: theme.sizes.radius['2xl'],
  objectFit: 'cover'
}));
const Image: React.FC<ImageProps> = t0 => {
  const $ = _c(7);
  const {
    src,
    alt: t1,
    width: t2,
    height: t3,
    fill: t4,
    className
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  const width = t2 === undefined ? 32 : t2;
  const height = t3 === undefined ? 32 : t3;
  const fill = t4 === undefined ? undefined : t4;
  const t5 = fill ? undefined : width;
  const t6 = fill ? undefined : height;
  let t7;
  if ($[0] !== alt || $[1] !== className || $[2] !== fill || $[3] !== src || $[4] !== t5 || $[5] !== t6) {
    t7 = <StyledImage src={src} alt={alt} fill={fill} width={t5} height={t6} className={className} />;
    $[0] = alt;
    $[1] = className;
    $[2] = fill;
    $[3] = src;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};
export default Image;
export type { ImageProps };